import React, { useContext, useState } from 'react';
import { Button, Pagination, Select, Space, Table, Skeleton, Empty } from "antd";
import { useQuery, useQueryClient } from "react-query";
import "../../styles/Report.css";
import Column from "antd/es/table/Column";
import DeleteModal from "../DeleteModal";
// import SearchFilter from "../../SearchFilter";
import useAxiosInstance from "../../lib/useAxiosInstance";
import { toast } from "react-toastify";
import excelIcon from "../../assets/images/ExcelFileImg.png"; 

const SocialMediaList = () => {
    const axiosInstance = useAxiosInstance();
    const queryClient = useQueryClient();

    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [total, setTotal] = useState(0);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [recordToDelete, setRecordToDelete] = useState(null);

    // FETCH SOCIAL MEDIA DATA
    const fetchSocialMedia = async () => {
        let response;
        if (searchKeyword) {
            response = await axiosInstance.get(
                `/api/social-media/getSM?keyword=${searchKeyword}&page=${currentPage}&limit=${limit}`
            );
        } else {
            response = await axiosInstance.get(
                `/api/social-media/getSM?page=${currentPage}&limit=${limit}`
            );
        }
        setTotal(response?.data?.totalPages || 0);
        return response;
    };

    const socialMediaQuery = useQuery(
        ["social-media-list", currentPage, limit, searchKeyword],
        fetchSocialMedia,
        { refetchOnWindowFocus: false, retry: 1 }
    );

    // SEARCH HANDLER
    // const handleSearch = (value) => {
    //     setCurrentPage(1);
    //     setSearchKeyword(value);
    // };

    // PAGINATION HANDLER
    const handlePageChange = (page, pageSize) => {
        setCurrentPage(page);
        setLimit(pageSize);
    };

    const pagination = {
        total: total * limit,
        pageSize: limit,
        current: currentPage,
        onChange: handlePageChange,
    };

    // DELETE HANDLER
    const handleShowModalDelete = (record) => {
        setRecordToDelete(record);
        setIsDeleteModalVisible(true);
    };

    const handleDelete = async (record) => {
        try {
            const response = await axiosInstance.delete(`/api/social-media/${record._id}`);
            toast.success(response?.data?.message || "Deleted successfully");
            queryClient.invalidateQueries("social-media-list");
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        }
    };

    const isLoading = socialMediaQuery?.isFetching || socialMediaQuery?.isLoading;
    console.log("socialMediaQuery",socialMediaQuery)
    return (
        <>
            {/* <div className="search-share">
                <SearchFilter handleSearch={handleSearch} />
            </div> */}

            <div className="reports-table">
                <Table
                    rowKey={(record) => record._id}
                    dataSource={socialMediaQuery?.data?.data?.data || []}
                    pagination={pagination}
                    locale={{
                        emptyText: isLoading ? (
                            <div style={{ marginLeft: "20px", width: "95%" }}>
                                <Skeleton
                                    title={false}
                                    active
                                    paragraph={{ rows: 6, width: ["100%", "100%", "100%", "100%", "100%", "100%"] }}
                                />
                            </div>
                        ) : (
                            <Empty />
                        ),
                    }}
                >
                    <Column 
                        title="CLIENT NAME" 
                        dataIndex="clientUser" 
                        render={(clientUser) => <span>{clientUser?.adminFirstName || "-"} {clientUser?.adminLastName || "-"}</span>} 
                    />
                    <Column title="DESCRIPTION" dataIndex="description" render={(text) => <span>{text}</span>} />
                    <Column 
                        title="ADDED BY" 
                        dataIndex="uploadedByUser" 
                        render={(uploadedByUser) => <span>{uploadedByUser?.firstName || "-"} {uploadedByUser?.lastName || "-"}</span>} 
                    />
                    <Column title="CREATED AT" dataIndex="createdAt"
                        render={(text) => <span>{new Date(text).toLocaleDateString("en-GB")}</span>} />
                    {/* DOWNLOAD COLUMN */}
                    <Column 
                        title="DOWNLOAD"
                        key="download"
                        render={(text, record) => (
                            <a 
                                href={record?.filePath?.publicUrl} 
                                download 
                                target="_blank" 
                                rel="noopener noreferrer"
                            >
                                <img src={excelIcon} alt="Download Excel" style={{ width: 24, cursor: "pointer" }} />
                            </a>
                        )}
                    />
                    <Column title="ACTION" key="action"
                        render={(text, record) => (
                            <Space size="small">
                                <Button type="link" onClick={() => handleShowModalDelete(record)}>Delete</Button>
                            </Space>
                        )}
                    />
                </Table>

                <div className="report-pagination">
                    <div>
                        <Select
                            value={limit.toString()}
                            style={{ width: 56 }}
                            onChange={(value) => { setLimit(parseInt(value)); setCurrentPage(1); }}
                            options={[
                                { value: "10", label: "10" },
                                { value: "20", label: "20" },
                                { value: "50", label: "50" },
                                { value: "100", label: "100" },
                            ]}
                        />
                        <span className="px-4">Entries Per Page</span>
                    </div>
                    <div className="report-selection">
                        <Pagination {...pagination} className="pagination" />
                    </div>
                </div>
            </div>

            {recordToDelete && (
                <DeleteModal
                    textheading="Delete Social Media"
                    deleteTitle="Social Media"
                    deleteBtn="Delete"
                    handleDelete={() => handleDelete(recordToDelete)}
                    isDeleteModal={isDeleteModalVisible}
                    showModalDelete={handleShowModalDelete}
                    action='delete'
                />
            )}
        </>
    );
};

export default SocialMediaList;
